import React from "react";
import { DatePicker } from "rsuite";
import { isBefore, isAfter } from "date-fns";
import { GetUserDateFormat } from "../utils/helper";
interface Props {
  disabledDate?: Date; // Disable the previous dates
  onChange?: any;
  value?: any;
  isValidate?: any;
  disabled?: boolean;
  disableDateCriteria?: string;
  disableAfterDate?: Date | string;
  placeholder?: string;
  Time?: boolean;
  displayDefaultValue?: boolean;
  startDate?: Date;
  endDate?: Date;
}

const handleDisabledDate = (date: any) => {
  const today = new Date();
  const age = today.getFullYear() - date.getFullYear();
  return age < 18 || age > 59;
};

function isSameDay(date1: Date, date2: Date) {
  return (
    date1.getDate() === date2.getDate() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}

const disableDate = (status: string | undefined, disableAfterDate?: any, startDate?: any, endDate?: any) => {
  switch (status) {
    case "disablePreviousDate":
      return (date?: any) => isBefore(date, new Date());
    case "disableFutureDate":
      return (date?: any) => isAfter(date, new Date());
    case "applyAgeCriteria":
      return (date?: any) => handleDisabledDate(date);
    case "disablePreviousDateWithOutToday":
      return (date?: any) => isBefore(date, new Date()) && !isSameDay(date, new Date())
    case "disableAfterDate":
      const parsedDate = new Date(disableAfterDate);
      parsedDate.setDate(parsedDate.getDate() + 1);
      return (date?: any) =>
        isBefore(date, parsedDate);
    // Disable dates before the start date for the end date picker
    case "disableDatesBeforeStartDate":
      return (date?: any) => startDate && (isBefore(date, new Date(startDate)) || isSameDay(date, new Date(startDate)));
    // Disable dates after the end date for start date picker
    case "disableDatesAfterEndDate":
      return (date?: any) => endDate && (isAfter(date, new Date(endDate)) || isSameDay(date, new Date(endDate)));
    // case "disableAllPreviousMonth":
    //   return (date?: any) => handleDisabledDate(date);
    default:
      return undefined;
  }
};

export const EPDatePicker: React.FC<Props> = ({
  disabled,
  disabledDate,
  onChange,
  value,
  isValidate,
  disableDateCriteria,
  placeholder,
  Time,
  displayDefaultValue,
  disableAfterDate,
  startDate,
  endDate
}) => {
  return (
    <DatePicker
      disabled={disabled ? disabled : false}
      oneTap
      value={value ? new Date(value) : null}
      placeholder={placeholder}
      format={Time ? GetUserDateFormat('dateTime') : GetUserDateFormat('date')}
      calendarDefaultDate={
        disableDateCriteria === "applyAgeCriteria"
          ? new Date(new Date().getFullYear() - 59, 0, 1)
          : undefined
      }
      disabledDate={disableDate(disableDateCriteria, disableAfterDate, startDate, endDate)}
      onChange={(date) => {
        onChange(date);
      }}
      defaultValue={displayDefaultValue ? new Date() : null}
      className={!value && isValidate ? "border border-danger" : ""}
    />
  );
};
